import { KEYCODES, CLASSES } from "@/scripts/helpers/constants";
import Autosuggest from "@/modules/components/uslf-search/autosuggest";

export default class UslfSearch {
  flags = {
    selectOpen: false
  };

  constructor(formSelector) {
    this.form = formSelector;
    this.searchField = $(this.form).find(".js-search-field");
    this.selectMask = $(this.form).find(".js-search-select-state");
    this.select = $(this.form).find(".search__select-state-input");
    this.selectItems = $(this.form).find(".search__options-list-item");
    this.autosuggestInstance = new Autosuggest(
      `${this.form} .js-search-field`,
      `${this.form} .search__combobox .js-search-options-list`
    );
  }

  removeFormFocus = () => {
    $(this.form).removeClass("focus-visible");
  };

  handleSearchFocus = () => {
    $(this.searchField).on("focus", () => {
      $(this.form).addClass("focus-visible");
      this.flags.searchFocused = true;
    });
  };

  makeSelectMaskFocusable = () => {
    if (window.matchMedia("(min-width: 640px)").matches) {
      $(this.selectMask).attr("tabIndex", "0");
      $(this.select).attr("tabIndex", "-1");
    } else {
      $(this.selectMask).removeAttr("tabIndex");
      $(this.select).removeAttr("tabIndex");
    }
  };

  showSelect = () => {
    $(this.form).addClass("focus-visible");
    $(this.selectMask).addClass(CLASSES.ACTIVE);
    $(this.selectItems)[0].focus();
    this.flags.selectOpen = true;
  };

  hideSelect = () => {
    $(this.selectMask).removeClass(CLASSES.ACTIVE);
    $(this.selectMask).focus();
    this.flags.selectOpen = false;
  };

  lockSelect = elem => {
    if (elem.length) {
      $(this.form).addClass("select-lock");
    }
  };

  lockReleaseSelect = () => {
    $(this.form).removeClass("select-lock");
  };

  changeSelectValue = (text, value) => {
    $(this.selectMask)
      .find(".search__select-state-body")
      .text(text);
    $(this.select).val(value);
    this.hideSelect();
  };

  handleDesktopSelect = () => {
    const changeSelectValue = (text, value) =>
      this.changeSelectValue(text, value);

    const hideSelect = () => this.hideSelect();
    const showSelect = () => this.showSelect();
    const flags = () => this.flags;
    const selectMask = () => this.selectMask;
    const form = $(this.form);

    this.makeSelectMaskFocusable();
    this.handleSearchFocus();

    $(this.selectMask)
      .on("focus", () => {
        $(this.form).addClass("focus-visible");
      })
      .on("click", () => {
        if (this.flags.selectOpen) {
          this.hideSelect();
        } else if (!form.is(".select-lock")) {
          this.showSelect();
        }
      })
      .on("keypress", function(e) {
        e.preventDefault();
      })
      .on("keyup", function(e) {
        e.preventDefault();

        if (e.keyCode === KEYCODES.SPACE || e.keyCode === KEYCODES.ENTER) {
          if (flags.selectOpen) {
            hideSelect();
          } else if (!form.is(".select-lock")) {
            showSelect();
          }
        }
        if (e.keyCode === KEYCODES.ESC) {
          hideSelect();
          selectMask.focus();
        }
      });

    $(this.selectItems)
      .on("focus", function() {
        $(this.form).addClass("focus-visible");
      })
      .on("click", function(e) {
        e.stopPropagation();

        changeSelectValue($(this).text(), $(this).attr("data-value"));
      })
      .on("keyup", function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (e.keyCode === KEYCODES.SPACE || e.keyCode === KEYCODES.ENTER) {
          changeSelectValue($(this).text(), $(this).attr("data-value"));
        }
      });
    $(this.select).change(function() {
      const selectValue = $(this).val();
      const selectText = $(this)
        .children(":selected")
        .text();
      changeSelectValue(selectText, selectValue);
    });
  };

  handleClose = () => {
    $(document).on("click", event => {
      const searchSelectState = $(this.form).find(".js-search-select-state");
      if (!$(event.target).closest($(searchSelectState)).length) {
        $(this.selectMask).removeClass(CLASSES.ACTIVE);
      }
      if (!$(event.target).closest($(this.form)).length) {
        $(this.form).removeClass("focus-visible");
      }
    });
  };

  init = () => {
    this.handleDesktopSelect();
    this.handleClose();
    this.autosuggestInstance.init();
  };
}
